import { Constants } from "./constants";

const BASE_URL = Constants.API_ENDPOINT;

//Division details
export const DIVISION_DETAILS = BASE_URL + "pboa/back-order/division-details";
export const VENDOR_DETAILS = BASE_URL + "pboa/back-order/vendors-details";
export const PART_DETAILS = BASE_URL + "pboa/back-order/part-details";
export const FILTER_BY_VENDOR = BASE_URL + "pboa/back-order/filters-by-vendor";
export const FILTER_BY_PART = BASE_URL + "pboa/back-order/filters-by-part";
export const VENDOR_DETAILS_SUB_FILTER =
  BASE_URL + "pboa/back-order/vendors-details";
export const VENDOR_DETAILS_SUB_FILTER_WITH_DATES =
  BASE_URL + "pboa/back-order/vendors-details-sub-filter";

//Download File
export const DOWNLOAD_FILE = BASE_URL + "pboa/download-file/get-s3-link";

//DI Adherence
export const DI_ADHERENCE = BASE_URL + "pboa/back-order-di/di-adherence";
export const DI_ADHERENCE_REPORT = BASE_URL + "pboa/back-order-di/di-report";
export const DI_ADHERENCE_COMPANY_CODE =
  BASE_URL + "pboa/back-order-di/company_code";
export const DI_ADHERENCE_LOCATION = BASE_URL + "pboa/back-order-di/di_location";
export const DI_ADHERENCE_TOTAL =
  BASE_URL + "pboa/back-order-di/di-adherence-total";

//Forecast
export const FORECAST_ADHERENCE =
  BASE_URL + "pboa/forecast-adherence/graph-data";
export const FORECAST_ADHERENCE_REPORT =
  BASE_URL + "pboa/forecast-adherence/download";
export const FORECAST_FILTERS_BY_PART =
  BASE_URL + "pboa/forecast-adherence/filters-by-part";
export const FORECAST_FILTERS_BY_VENDOR =
  BASE_URL + "pboa/forecast-adherence/filters-by-vendor";
export const FORECAST_LOCATION = BASE_URL + "pboa/forecast-adherence/location";
export const FORECAST_VENDOR_DETAILS =
  BASE_URL + "pboa/forecast-adherence/vendors-details";
export const FORECAST_PART_DETAILS =
  BASE_URL + "pboa/forecast-adherence/part-details";

//BO Trend
export const GRAPH_DATA_DIVISION_DEPT =
  BASE_URL + "pboa/back-order/graph-data-div-dept";
export const VENDOR_TABLE = BASE_URL + "pboa/back-order/vendor-table";
export const BO_TREND_REPORT = BASE_URL + "pboa/back-order/download";

//BO Part
export const LOCATION_DETAILS = BASE_URL + "pboa/bo-part/location";
export const BO_RANGE = BASE_URL + "pboa/bo-part/bo-range";
export const BO_CARD_VALUE = BASE_URL + "pboa/bo-part/bo-card-value";
export const BO_DIVISION_VALUE = BASE_URL + "pboa/bo-part/bo-division-value";
export const BO_GRAPH_VALUE = BASE_URL + "pboa/bo-part/bo-graph-value";
export const BO_TABLE_DATA = BASE_URL + "pboa/bo-part/bo-table-data";
export const BO_DATA_DOWNLOAD = BASE_URL + "pboa/bo-part/bo-data-download";
export const BO_LOCATION_DOWNLOAD =
  BASE_URL + "pboa/bo-part/download-location-source-file";

//BO Trend Warehouse
export const WAREHOUSE_TABLE_DATA = BASE_URL + "pboa/bo-warehouse/table-data";
export const WAREHOUSE_GRAPH_DATA = BASE_URL + "pboa/bo-warehouse/graph-data";
export const WAREHOUSE_REPORT = BASE_URL + "pboa/bo-warehouse/download";

//User
export const ADMIN_CREATE_USER = BASE_URL + "pboa/admin/create-user";
export const ADMIN_ROLES = BASE_URL + "pboa/admin/roles";
export const ADMIN_UPDATE_USER = BASE_URL + "pboa/admin/update-user";
export const ADMIN_USERS = BASE_URL + "pboa/admin/users";
export const ADMIN_DELETE_USER = BASE_URL + "pboa/admin/delete-user";
export const ADMIN_CURRENT_USER = BASE_URL + "pboa/admin/current-user-details";

//BO VPU Not Available
export const BO_VPU_DATA = BASE_URL + "pboa/bo-vpu/notAvailable";
export const BO_VPU_TABLE = BASE_URL + "pboa/bo-vpu/table";
export const BO_VPU_REPORT = BASE_URL + "pboa/bo-vpu/download";
export const BO_VPU_VENDOR_DETAILS = BASE_URL + "pboa/bo-vpu/vendor-details";
export const BO_VPU_FILTERS_BY_VENDOR =
  BASE_URL + "pboa/bo-vpu/filters-by-vendor";

//CARTON SUMMARY
export const CARTON_TABLE =
  BASE_URL + "pboa/carton-summary/planned-vs-received-table";
export const CARTON_GRAPH =
  BASE_URL + "pboa/carton-summary/planned-vs-received-graph";
export const CARTON_PLANNED_GRAPH =
  BASE_URL + "pboa/carton-summary/planned-carton";
export const CARTON_REPORT =
  BASE_URL + "pboa/carton-summary/download-planned-vs-received";
export const CARTON_PLANNED_REPORT =
  BASE_URL + "pboa/carton-summary/download-planned-carton";
export const CARTON_COMP_CODE = BASE_URL + "pboa/carton-summary/comp-code";
export const CARTON_DI_LOCATION = BASE_URL + "pboa/carton-summary/di-location";

//Dealer Top 50
export const DEALER_TOP_DEPARTMENT_GRAPH =
  BASE_URL + "pboa/dealer-top-50/department-graph";
export const DEALER_TOP_TABLE_DATA = BASE_URL + "pboa/dealer-top-50/table-data";
export const DEALER_TOP_FILTER = BASE_URL + "pboa/dealer-top-50/filter";
export const DEALER_TOP_AVG_TREND =
  BASE_URL + "pboa/dealer-top-50/avg-trend-data";
export const DEALER_TOP_REPORT = BASE_URL + "pboa/dealer-top-50/download";
export const DEALER_TOP_PART_DETAILS =
  BASE_URL + "pboa/dealer-top-50/part-details";

//Model wise BO
export const MODEL_WISE_GET_MODELS =
  BASE_URL + "pboa/back-order-model/get-models";
export const MODEL_WISE_DATA =
  BASE_URL + "pboa/back-order-model/model-wise-data";
export const MODEL_WISE_COMPOSITION =
  BASE_URL + "pboa/back-order-model/model-wise-composition";
export const MODEL_WISE_REPORT =
  BASE_URL + "pboa/back-order-model/model-wise-data-report";
export const MODEL_WISE_TABLE_DATA =
  BASE_URL + "pboa/back-order-model/model-wise-table-data";

//PO and Pricing
export const PO_BUYER_DETAILS =
  BASE_URL + "pboa/po-pending-pricing-sob/buyer-code-details";
export const PO_GRAPH_DATA = BASE_URL + "pboa/po-pending-pricing-sob/graph-data";
export const PO_REPORT_DOWNLOAD =
  BASE_URL + "pboa/po-pending-pricing-sob/download";
export const PO_TABLE_DATA = BASE_URL + "pboa/po-pending-pricing-sob/table-data";

//KD Stock
export const KD_VENDOR_DETAILS = BASE_URL + "pboa/kd-stock/vendors-details";
export const KD_FILTER_BY_VENDOR = BASE_URL + "pboa/kd-stock/filters-by-vendor";
export const KD_BUYER_CODE_DETAILS =
  BASE_URL + "pboa/kd-stock/buyer-code-details";
export const KD_DI_LOCATION_DETAILS = BASE_URL + "pboa/kd-stock/di-location";
export const KD_PARENT_PART_DETAILS =
  BASE_URL + "pboa/kd-stock/parent-part-details";
export const KD_CHILD_PART_DETAILS =
  BASE_URL + "pboa/kd-stock/child-part-details";
export const KD_DEPT_GRAPH_TABLE =
  BASE_URL + "pboa/kd-stock/dept-wise-stock-data";
export const KD_VENDOR_GRAPH_TABLE =
  BASE_URL + "pboa/kd-stock/vendor-wise-stock-data";
export const KD_STOCK_TABLE = BASE_URL + "pboa/kd-stock/kd-stock-table";
export const KD_DI_TABLE = BASE_URL + "pboa/kd-stock/di-table";
export const KD_MTD_TABLE = BASE_URL + "pboa/kd-stock/mtd-table";
export const KD_STOCK_DOWNLOAD = BASE_URL + "pboa/kd-stock/download-kd-stock";
export const KD_DI_DOWNLOAD = BASE_URL + "pboa/kd-stock/download-di";
export const KD_MTD_DOWNLOAD = BASE_URL + "pboa/kd-stock/download-mtd";

//AOBO
export const AOBO_RANGE = BASE_URL + "pboa/aobo/aobo-range";
export const AOBO_BUYER_CODE_DETAILS = BASE_URL + "pboa/aobo/buyer-code-details";
export const AOBO_COMP_CODE = BASE_URL + "pboa/aobo/comp-code";
export const AOBO_DOWNLOAD = BASE_URL + "pboa/aobo/download";
export const AOBO_GRAPH_DATA_TIMELINE =
  BASE_URL + "pboa/aobo/graph-data-timeline";
export const AOBO_GRAPH_DATA_VALUE_QTY =
  BASE_URL + "pboa/aobo/graph-data-value-qty";
export const AOBO_TABLE_DATA = BASE_URL + "pboa/aobo/table-data";
export const AOBO_PART_DETAILS = BASE_URL + "pboa/aobo/part-details";

//MANUAL FILE UPLOAD
export const MANUAL_DOWNLOAD_TEMPLATE =
  BASE_URL + "pboa/manual-file-upload/download-template";
export const MANUAL_GENERATE_S3_URL =
  BASE_URL + "pboa/manual-file-upload/generate-s3-pre-signed-url";
export const MANUAL_TABLE =
  BASE_URL + "pboa/manual-file-upload/uploaded-files-table";
export const MANUAL_VALIDATE_UPLOADED_FILE =
  BASE_URL + "pboa/manual-file-upload/upload-file-details";
export const MANUAL_DOWNLOAD_HISTORICAL_FILE =
  BASE_URL + "pboa/manual-file-upload/download-historical-file";

//CUSTOMIZE HOME SCREEN
export const HOME_SCREEN_ADD_TILES = BASE_URL + "pboa/home-screen/add-tiles";
export const HOME_SCREEN_GET_TILES = BASE_URL + "pboa/home-screen/get-tiles";
